import React, { useState } from 'react';
import ProductCard from './ProductCard';

const ProductSection = ({ title, products, showViewAll = true }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerPage = 4;

  const nextProducts = () => {
    if (currentIndex + itemsPerPage < products.length) {
      setCurrentIndex(currentIndex + itemsPerPage);
    }
  };

  const prevProducts = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - itemsPerPage);
    }
  };

  const visibleProducts = products.slice(currentIndex, currentIndex + itemsPerPage);

  const arrowButtonClasses =
    'inline-flex items-center justify-center rounded-full w-9 h-9 transition-colors ' +
    'border border-black/10 text-[#1B1B1F] hover:bg-[#1B1B1F] hover:text-white hover:border-[#1B1B1F] ' +
    'disabled:opacity-30 disabled:hover:bg-transparent disabled:hover:text-[#1B1B1F] disabled:cursor-not-allowed ' +
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F2B705] focus-visible:ring-offset-2';

  const viewAllClasses =
    'inline-flex items-center justify-center whitespace-nowrap rounded-full text-sm font-bold ' +
    'border border-[#1B1B1F]/15 text-[#1B1B1F] hover:bg-[#1B1B1F] hover:text-white transition-colors ' +
    'px-5 py-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F2B705] focus-visible:ring-offset-2';

  return (
    <section className="py-12">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="flex items-center justify-between mb-8">
          <h2
            className="text-2xl md:text-3xl font-bold text-[#1B1B1F]"
            style={{ fontFamily: "'Baloo Bhaijaan 2', sans-serif" }}
          >
            {title}
          </h2>

          <div className="flex items-center gap-4">
            {/* Navigation Arrows */}
            <div className="flex gap-2">
              <button
                aria-label="السابق"
                className={arrowButtonClasses}
                onClick={prevProducts}
                disabled={currentIndex === 0}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-4 h-4"
                >
                  <path d="m9 18 6-6-6-6" />
                </svg>
              </button>
              <button
                aria-label="التالي"
                className={arrowButtonClasses}
                onClick={nextProducts}
                disabled={currentIndex + itemsPerPage >= products.length}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="w-4 h-4"
                >
                  <path d="m15 18-6-6 6-6" />
                </svg>
              </button>
            </div>

            {showViewAll && (
              <button className={`${viewAllClasses} hidden md:flex`}>
                عرض الكل
              </button>
            )}
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {visibleProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>

        {/* Mobile View All Button */}
        {showViewAll && (
          <div className="flex justify-center mt-8 md:hidden">
            <button className={`${viewAllClasses} w-full max-w-xs`}>
              عرض الكل
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProductSection;
